module.exports = __webpack_public_path__ + "img/bear3.39447b3f.svg";